export default "__VITE_ASSET__a0b03127__"